module.exports = __webpack_public_path__ + "media/images/illustrations/wave-white-1-e37865e72170a060ac5772810da4a77b.svg";